<template>
  <el-container
    style="height: 100%; background-color: #070809;min-width: 1440px;"
    :style="{ 'min-width': isPc == 1 ? '1440px' : '100%' }"
  >
    <el-aside
      style="height:100%;overflow:hidden;width: 8%"
      v-show="login == false"
      ref="navAside"
    >
      <div class="img-div">
        <img src="./assets/logo.png" />
      </div>
      <el-menu
        text-color="#eee"
        active-text-color="#fff"
        background-color="#070809"
        style="overflow:auto;height:calc(100% - 130px);padding:10px;margin:0;"
        router
        :default-active="active"
        @select="menuRouter"
      >
        <!-- <div class="menu-title">{{
          $t("m.index.device.title")
        }}</div> -->
        <!-- <el-menu-item index="/on-deviceList" @click="activeImg = 1">
          <img v-if="activeImg == 1" src="./assets/img/基本信息-已选择.png" />
          <img v-else src="./assets/img/基本信息-未选择.png" />
          <span style="padding-left: 5px">{{
            $t("m.index.device.bindDevice")
          }}</span>

        </el-menu-item> -->
        <el-menu-item
          index="/on-allUserDeviceList"
          @click="activeImg = 2"
        >
          <img
            v-if="activeImg == 2"
            src="./assets/icons/设备列表选中@3x.png"
          />
          <img v-else src="./assets/icons/设备列表未选@3x.png" />
          <span style="padding-left: 5px">{{
            $t("m.index.device.bindDevice")
          }}</span>

        </el-menu-item>

        <!-- <div class="menu-title">{{
          $t("m.index.chart.title")
        }}</div> -->
        <el-menu-item index="/on-curveList" @click="activeImg = 3">
          <img v-if="activeImg == 3" src="./assets/icons/曲线列表选中@3x.png" />
          <img v-else src="./assets/icons/曲线列表未选@3x.png" />
          <span style="padding-left: 5px">{{
            $t("m.index.chart.myChart")
          }}</span>

        </el-menu-item>
        <!-- <el-menu-item index="/on-curveRecommend" @click="activeImg = 4">
          <img
            v-if="activeImg == 4"
            src="./assets/img/测试题目-已选择(4).png"
          />
          <img v-else src="./assets/img/测试题目-未选择(4).png" />
          <span style="padding-left: 5px">{{
            $t("m.index.chart.recommendChart")
          }}</span>

        </el-menu-item>
        <el-menu-item index="/on-curveCollect" @click="activeImg = 5">
          <img
            v-if="activeImg == 5"
            src="./assets/img/测试题目-已选择(5).png"
          />
          <img v-else src="./assets/img/测试题目-未选择(5).png" />
          <span style="padding-left: 5px">{{
            $t("m.index.chart.collChart")
          }}</span>

        </el-menu-item>
        <el-menu-item
          v-if="role == 1"
          index="/on-allUserCurveList"
          @click="activeImg = 6"
        >
          <img
            v-if="activeImg == 6"
            src="./assets/img/测试题目-已选择(7).png"
          />
          <img v-else src="./assets/img/测试题目-未选择(7).png" />
          <span style="padding-left: 5px">{{
            $t("m.index.chart.userChart")
          }}</span>

        </el-menu-item> -->

        <!-- <div class="menu-title">{{
          $t("m.index.cup.title")
        }}</div> -->
        <!-- <el-menu-item index="/on-cupList" @click="activeImg = 7">
          <img
            v-if="activeImg == 7"
            src="./assets/img/测试题目-已选择(1).png"
          />
          <img v-else src="./assets/img/测试题目-未选择(1).png" />
          <span style="padding-left: 5px">{{
            $t("m.index.cup.myCupEvaluate")
          }}</span>

        </el-menu-item> -->
        <el-menu-item v-if="role == 1"
          index="/on-allUserCupList"
          @click="activeImg = 8"
        >
          <img
            v-if="activeImg == 8"
            src="./assets/icons/杯测列表选中@3x.png"
          />
          <img v-else src="./assets/icons/杯测列表未选@3x.png" />
          <span style="padding-left: 5px">{{
            $t("m.index.cup.myCupEvaluate")
          }}</span>

        </el-menu-item>

<!--        class="divider1"-->
        <!-- <div class="menu-title"
          >{{ $t("m.index.bean.title") }}</div
        > -->
        <!-- <el-menu-item index="/on-storageStatus" @click="activeImg = 9">
          <img
            v-if="activeImg == 9"
            src="./assets/img/测试题目-未选择(2).png"
          />
          <img v-else src="./assets/img/测试题目-未选择(2).png" />
          <span style="padding-left: 5px">{{ $t("m.index.bean.myBean") }}</span>

        </el-menu-item> -->

        <el-menu-item
          index="/on-allUserStorage"
          @click="activeImg = 11"
        >
          <img
            v-if="activeImg == 11"
            src="./assets/icons/用户仓储选中@3x.png"
          />
          <img v-else src="./assets/icons/用户仓储未选@3x.png" />
          <span style="padding-left: 5px">{{
            $t("m.index.bean.myBean")
          }}</span>

        </el-menu-item>
        <!-- <el-menu-item index="/on-recomStatus" @click="activeImg = 10">
          <img
            v-if="activeImg == 10"
            src="./assets/icons/工厂推荐选中@3x.png"
          />
          <img v-else src="./assets/icons/工厂推荐未选@3x.png" />
          <span style="padding-left: 5px">{{
            $t("m.index.bean.factoryRecommend")
          }}</span>

        </el-menu-item> -->
<!--        class="divider1"-->
        <!-- <div class="menu-title"
          >{{ $t("m.index.setting.title") }}</div
        > -->
        <el-menu-item v-if="role == 1" index="/on-systemSetting" @click="activeImg = 12">
          <img
            v-if="activeImg == 12"
            src="./assets/icons/系统设置选中@3x.png"
          />
          <img v-else src="./assets/icons/系统设置未选@3x.png" />
          <span style="padding-left: 5px">{{
            $t("m.index.setting.systemSetting")
          }}</span>

        </el-menu-item>
        <!-- <el-menu-item index="/on-accountManagement" @click="activeImg = 13">
          <img
            v-if="activeImg == 13"
            src="./assets/img/测试题目-已选择(10).png"
          />
          <img v-else src="./assets/img/测试题目-未选择(10).png" />
          <span style="padding-left: 5px">{{
            $t("m.index.setting.accountManage")
          }}</span>

        </el-menu-item> -->
        <el-menu-item
          v-if="role == 1"
          index="/on-userManagement"
          @click="activeImg = 14"
        >
          <img
            v-if="activeImg == 14"
            src="./assets/icons/用户管理选中@3x.png"
          />
          <img v-else src="./assets/icons/用户管理未选@3x.png" />
          <span style="padding-left: 5px">{{
            $t("m.index.setting.userManage")
          }}</span>

        </el-menu-item>
        <el-menu-item
          v-if="role == 1"
          index="/on-deviceTypeSet"
          @click="activeImg = 15"
        >
          <img
            v-if="activeImg == 15"
            src="./assets/icons/设备类型管理选中@3x.png"
          />
          <img v-else src="./assets/icons/设备类型管理未选@3x.png" />
          <span style="padding-left: 5px">{{
            $t("m.index.setting.settingDeviceType")
          }}</span>

        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header
        v-show="login == false"
        style="text-align: right; font-size: 12px;"
      >
        <el-row>
          <!-- <el-col :span="12"
            ><el-breadcrumb
              separator="/"
              separator-class="el-icon-arrow-right"
              style="height: 30px;width:300px;margin-top: 24px; font-size: 15px"
            >
              <el-breadcrumb-item>{{ $t("m.location") }}</el-breadcrumb-item>
              <el-breadcrumb-item>{{ activeLabelParent }}</el-breadcrumb-item>
              <el-breadcrumb-item>{{ activeLabel }}</el-breadcrumb-item>
            </el-breadcrumb></el-col
          > -->
          <el-col
       
            style="height:60px;padding-top: 3px;"
          >
           
            <el-dropdown
              @command="handleCommand"
              style="margin-left: 15px;margin-top: 12px;"
            >
            <div class="el-dropdown-link">
              <div style="font-size: 18px;color:#7B7D8D;">{{ userName }}</div>
              <img src="@/assets/icons/user.png" alt="" width="30px">
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="accountManage">{{
                  $t("m.index.setting.accountManage")
                }}</el-dropdown-item>
                <el-dropdown-item command="logout">{{
                  $t("m.logout")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-header>
      <el-main style="flex-basis:800px;">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
const item = {
  date: "2016-05-02",
  name: "王小虎",
  address: "上海市普陀区金沙江路 1518 弄",
};
export default {
  name: "commonApp",
  data() {
    return {
      tableData: Array(20).fill(item),
      login: false,
      userName: "",
      active: "/on-deviceList",
      activeImg: 1,
      photo: "",
      role: 0,
      activeLabel: "",
      activeLabelParent: "",
      logoutPng: require("./assets/logout.png"),
      language: "中文",
      isPc: 1,
    };
  },
  created: function() {
    console.info(this.$route.path);
    if (
      this.$route.path == "/login" ||
      this.$route.path == "/register" ||
      this.$route.path == "/forget"
    ) {
      this.login = true;
    } else {
      this.login = false;
      // this.$router.push('/user-list');
    }
    if (this.login == false) {
      this.userName = localStorage.userName;
      this.photo = localStorage.photo;
      this.role = localStorage.role;
    }
    //this.$router.push('/deviceList');
  },
  mounted() {
    // console.log(this.$i18n.locale);
    if (localStorage.aqbCofeLang == "en-US") {
      this.changeLanguage("en-US");
    } else if (localStorage.aqbCofeLang == "zh-CN") {
      this.changeLanguage("zh-CN");
    } else {
      this.changeLanguage("zh-CN");
    }
    this.IsPC();
    this.isPc = localStorage.coffeIsPc;
    console.info(this.$route.path);
    this.activeLabelParent = this.$t("m.index.device.title");
    this.activeLabel = this.$t("m.index.device.bindDevice");
    if (
      this.$route.path == "/login" ||
      this.$route.path == "/register" ||
      this.$route.path == "/forget"
    ) {
      this.login = true;
    } else {
      this.login = false;
      // this.$router.push('/user-list');
    }
    if (this.login == false) {
      this.userName = localStorage.userName;
      this.photo = localStorage.photo;
      this.role = localStorage.role;
    }
    //this.$router.push('/deviceList');
  },
  watch: {
    $route(to) {
      if (to.path === "recommend-report") {
        this.loadReportList();
      }
      console.info(this.$route.path);
      if (
        this.$route.path == "/login" ||
        this.$route.path == "/register" ||
        this.$route.path == "/forget"
      ) {
        this.login = true;
      } else {
        this.login = false;
        setTimeout(() => {
          this.$refs["navAside"].$el.scrollIntoView();
        }, 500);
      }
      if (this.login == false) {
        this.userName = localStorage.userName;
        this.photo = localStorage.photo;
        this.role = localStorage.role;
      }

      if (this.$route.path == "/on-deviceList") {
        this.activeLabelParent = this.$t("m.index.device.title");
        this.activeLabel = this.$t("m.index.device.bindDevice");
        this.active = "/on-deviceList";
        this.activeImg = 1;
      }
      if (this.$route.path == "/on-allUserDeviceList") {
        this.activeLabelParent = this.$t("m.index.device.title");
        this.activeLabel = this.$t("m.index.device.deviceList");
        this.active = "/on-allUserDeviceList";
        this.activeImg = 2;
      }
      if (this.$route.path == "/on-curveList") {
        this.activeLabelParent = this.$t("m.index.chart.title");
        this.activeLabel = this.$t("m.index.chart.myChart");
        this.active = "/on-curveList";
        this.activeImg = 3;
      }
      if (this.$route.path == "/on-curveRecommend") {
        this.activeLabelParent = this.$t("m.index.chart.title");
        this.activeLabel = this.$t("m.index.chart.recommendChart");
        this.active = "/on-curveRecommend";
        this.activeImg = 4;
      }
      if (this.$route.path == "/on-curveCollect") {
        this.activeLabelParent = this.$t("m.index.chart.title");
        this.activeLabel = this.$t("m.index.chart.collChart");
        this.active = "/on-curveCollect";
        this.activeImg = 5;
      }
      if (this.$route.path == "/on-allUserCurveList") {
        this.activeLabelParent = this.$t("m.index.chart.title");
        this.activeLabel = this.$t("m.index.chart.userChart");
        this.active = "/on-allUserCurveList";
        this.activeImg = 6;
      }
      if (this.$route.path == "/on-cupList") {
        this.activeLabelParent = this.$t("m.index.cup.title");
        this.activeLabel = this.$t("m.index.cup.myCupEvaluate");
        this.active = "/on-cupList";
        this.activeImg = 7;
      }
      if (this.$route.path == "/on-allUserCupList") {
        this.activeLabelParent = this.$t("m.index.cup.title");
        this.activeLabel = this.$t("m.index.cup.userCupEvaluate");
        this.active = "/on-allUserCupList";
        this.activeImg = 8;
      }
      if (this.$route.path == "/on-storageStatus") {
        this.activeLabelParent = this.$t("m.index.bean.title");
        this.activeLabel = this.$t("m.index.bean.myBean");
        this.active = "/on-storageStatus";
        this.activeImg = 9;
      }
      if (this.$route.path == "/on-recomStatus") {
        this.activeLabelParent = this.$t("m.index.bean.title");
        this.activeLabel = this.$t("m.index.bean.factoryRecommend");
        this.active = "/on-recomStatus";
        this.activeImg = 10;
      }
      if (this.$route.path == "/on-allUserStorage") {
        this.activeLabelParent = this.$t("m.index.bean.title");
        this.activeLabel = this.$t("m.index.bean.userBean");
        this.active = "/on-allUserStorage";
        this.activeImg = 11;
      }
      if (this.$route.path == "/on-systemSetting") {
        this.activeLabelParent = this.$t("m.index.setting.title");
        this.activeLabel = this.$t("m.index.setting.systemSetting");
        this.active = "/on-systemSetting";
        this.activeImg = 12;
      }
      // if (this.$route.path == "/on-accountManagement") {
      //   this.activeLabelParent = this.$t("m.index.setting.title");
      //   this.activeLabel = this.$t("m.index.setting.accountManage");
      //   this.active = "/on-accountManagement";
      //   this.activeImg = 13;
      // }
      if (this.$route.path == "/on-userManagement") {
        this.activeLabelParent = this.$t("m.index.setting.title");
        this.activeLabel = this.$t("m.index.setting.userManage");
        this.active = "/on-userManagement";
        this.activeImg = 14;
      }
      if (this.$route.path == "/on-deviceTypeSet") {
        this.activeLabelParent = this.$t("m.index.setting.title");
        this.activeLabel = this.$t("m.index.setting.settingDeviceType");
        this.active = "/on-deviceTypeSet";
        this.activeImg = 15;
      }
    },
  },
  methods: {
    changeLanguage(command) {
      if (command == "zh-CN") {
        this.$i18n.locale = "zh-CN"; //关键语句
        this.language = "中文";
      } else {
        this.$i18n.locale = "en-US"; //关键语句
        this.language = "English";
      }
    },
    handleCommand(command) {
      if (command == "logout") {
        this.logout();
      } else if (command == 'accountManage') {
        this.activeLabelParent = this.$t("m.index.setting.title");
        this.activeLabel = this.$t("m.index.setting.accountManage");
        this.active = "/on-accountManagement";
        this.activeImg = 13;
        this.$router.push("/on-accountManagement");
      }
    },
    logout() {
      this.$confirm(this.$t("m.alert.logout"), this.$t("m.alert.reminder"), {
        confirmButtonText: this.$t("m.alert.confirm"),
        cancelButtonText: this.$t("m.alert.cancel"),
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/manage/user/logout.do")
            .then(
              function(resp) {
                console.info(resp);
                let language = localStorage.aqbCofeLang;
                localStorage.clear();
                localStorage.aqbCofeLang = language;
                this.$router.push("/login");
              }.bind(this)
            )
            .catch((err) => {
              console.info(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.canceled"),
          });
        });
    },

    menuRouter: function(index, indexPath) {
      if (index == "0") {
        return;
      }
      console.info(index);
      console.info(indexPath);

      if (index.indexOf("index") != -1) {
        this.activeLabelParent = this.$t("m.index.device.title");
        this.activeLabel = this.$t("m.index.device.bindDevice");
      }
      if (index.indexOf("on-deviceList") != -1) {
        this.activeLabelParent = this.$t("m.index.device.title");
        this.activeLabel = this.$t("m.index.device.bindDevice");
      }
      if (index.indexOf("on-allUserDeviceList") != -1) {
        this.activeLabelParent = this.$t("m.index.device.title");
        this.activeLabel = this.$t("m.index.device.deviceList");
      }
      if (index.indexOf("on-curveList") != -1) {
        this.activeLabelParent = this.$t("m.index.chart.title");
        this.activeLabel = this.$t("m.index.chart.myChart");
      }
      if (index.indexOf("on-curveRecommend") != -1) {
        this.activeLabelParent = this.$t("m.index.chart.title");
        this.activeLabel = this.$t("m.index.chart.recommendChart");
      }
      if (index.indexOf("on-curveCollect") != -1) {
        this.activeLabelParent = this.$t("m.index.chart.title");
        this.activeLabel = this.$t("m.index.chart.collChart");
      }
      if (index.indexOf("on-allUserCurveList") != -1) {
        this.activeLabelParent = this.$t("m.index.chart.title");
        this.activeLabel = this.$t("m.index.chart.userChart");
      }
      if (index.indexOf("on-cupList") != -1) {
        this.activeLabelParent = this.$t("m.index.cup.title");
        this.activeLabel = this.$t("m.index.cup.myCupEvaluate");
      }
      if (index.indexOf("on-allUserCupList") != -1) {
        this.activeLabelParent = this.$t("m.index.cup.title");
        this.activeLabel = this.$t("m.index.cup.userCupEvaluate");
      }
      if (index.indexOf("on-storageStatus") != -1) {
        this.activeLabelParent = this.$t("m.index.bean.title");
        this.activeLabel = this.$t("m.index.bean.myBean");
      }
      if (index.indexOf("on-recomStatus") != -1) {
        this.activeLabelParent = this.$t("m.index.bean.title");
        this.activeLabel = this.$t("m.index.bean.factoryRecommend");
      }
      if (index.indexOf("on-allUserStorage") != -1) {
        this.activeLabelParent = this.$t("m.index.bean.title");
        this.activeLabel = this.$t("m.index.bean.userBean");
      }
      if (index.indexOf("on-systemSetting") != -1) {
        this.activeLabelParent = this.$t("m.index.setting.title");
        this.activeLabel = this.$t("m.index.setting.systemSetting");
      }
      if (index.indexOf("on-accountManagement") != -1) {
        this.activeLabelParent = this.$t("m.index.setting.title");
        this.activeLabel = this.$t("m.index.setting.accountManage");
      }
      if (index.indexOf("on-userManagement") != -1) {
        this.activeLabelParent = this.$t("m.index.setting.title");
        this.activeLabel = this.$t("m.index.setting.userManage");
      }
      if (index.indexOf("on-deviceTypeSet") != -1) {
        this.activeLabelParent = this.$t("m.index.setting.title");
        this.activeLabel = this.$t("m.index.setting.settingDeviceType");
      }

      if (index.indexOf("user-guide") != -1) {
        this.activeLabel = this.$t("m.index.setting.userGuide");
      }
      if (index.indexOf("about") != -1) {
        this.activeLabel = this.$t("m.index.setting.about");
      }
      if (index.indexOf("event-manage") != -1) {
        this.activeLabel = this.$t("m.index.setting.quickEventManage");
      }
      if (index.indexOf("user-List") != -1) {
        this.activeLabel = this.$t("m.index.userManage");
      }
      //this.$router.push(index)
    },
    IsPC: function() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      var flag = 0;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = 1;
          break;
        }
      }
      localStorage.coffeIsPc = flag;
    },
  },
};
</script>

<style scoped>
.el-main {
  padding: 0;
}

.el-menu {
  background-color: transparent !important;
}

.img-div {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.img-div img {
  width: 125px;
}
.el-menu-item {
  display: flex;
  align-items: center;
  height: 40px;
  margin-left: 10px;
  margin: 14px 0px 14px 12px;
  border-radius: 8px;
}

.el-divider {
  height: 2px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.el-divider /deep/ .el-divider__text {
  padding: 0 10px;
  background-color: #070809;
  color: white;
}

.el-divider.divider1 /deep/ .el-divider__text {
  background-color: #141516;
}

.el-divider el-divider--horizontal {
  color: #dddddd;
}

.el-menu {
  margin: 20px;
  border-right: 0 !important;
}
@media screen and (max-width: 1700px) {
  .img-div img {
    width: 100px;
  }
}
</style>
<style>
html,
body {
  overflow-y: hidden;
}

.el-dropdown-menu.el-popper {
  position: fixed !important;
  background-color: #000000 !important;
}
.menu-title {
  padding-left: 30px;
  margin: 15px 0;
}
.el-dropdown-link {
  display: flex;
  align-items: center;
  gap: 10px;
}
.el-icon--right {
  padding: 6px;
  color: #fc9153;
  border-radius: 5px;
  background: #363636;
  font-weight: bold !important;
}
.el-menu-item img{
  width: 32px;
}
.el-menu-item span {
  font-size: 16px;
}

.el-menu-item.is-active:hover {
  background-color: rgb(51, 51, 51) !important;
}

.el-menu-item:hover {
  background-color: #26282d !important;
}

</style>
